import React from 'react';
import OrdersTable from './OrdersTable';
import {filterOrders, ORDER_SEGMENTS} from './orderFilters';

function Totals({label, totals = []}) {
  return (
    <p className="subtitle">
      {label}:{' '}
      <strong>
        {totals.map(total => `${total.formattedAmount} ${total.currency}`).join(' · ')}
      </strong>
    </p>
  );
}

/**
 * Reusable order list. Callers feed it a shared order collection and choose a
 * segment; multiple instances can render overlapping views of the same orders.
 */
function OrderList({
  orders = [],
  segment = ORDER_SEGMENTS.ALL,
  title,
  id,
  totals,
  totalsLabel,
  emptyMessage = 'No orders in this list.',
  hideWhenEmpty = false,
  beforeTable,
  children,
  busyOrderId,
  onMarkPaid,
  onDelete,
}) {
  const visibleOrders = filterOrders(orders, segment);
  if (hideWhenEmpty && visibleOrders.length === 0) return null;

  return (
    <section id={id} className={`order-list order-list--${segment}`}>
      {title && <h2>{title}</h2>}
      {segment === ORDER_SEGMENTS.ATTENTION && (
        <p className="subtitle">
          Total orders needing attention: <strong>{visibleOrders.length}</strong>
        </p>
      )}
      {totalsLabel && <Totals label={totalsLabel} totals={totals} />}
      {beforeTable}
      {visibleOrders.length > 0 ? (
        <OrdersTable
          orders={visibleOrders}
          variant={segment}
          busyOrderId={busyOrderId}
          onMarkPaid={onMarkPaid}
          onDelete={onDelete}
        />
      ) : (
        <p className="orders-empty">{emptyMessage}</p>
      )}
      {children}
    </section>
  );
}

export default OrderList;
